import { Group, Stack, Text, ThemeIcon } from "@mantine/core";
import PanelSender from "./PanelSender";
import PanelModel from "./PanelModel";
import { useMemo } from "react";
import { getNodeDetails } from "../flowSettings";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";

const NodePanelMain = ({ clickedNode }) => {
  const nodes = useFlowStore(s => s.nodes);

  const node = nodes.find(x => x.id === clickedNode?.id);

  const nodeDetail = useMemo(
    () => getNodeDetails(node?.data.actionType),
    [node]
  );

  return (
    <Stack gap={0} key={node?.id} pt={10}>
      <Group mb={16}>
        <ThemeIcon variant="light" color={nodeDetail?.color} size={"lg"}>
          {nodeDetail?.icon}
        </ThemeIcon>
        <Text fz={"lg"}>{nodeDetail?.label}</Text>
        <Text opacity={0.35}>
          #{node?.id}
        </Text>
      </Group>

      {!["sms", "smv", "split_contacts", "call"].includes(node?.data?.actionType) && (
        <PanelSender node={node} />
      )}

      {!["linkedin_visit", "split_contacts", "call"].includes(node?.data?.actionType) && (
        <PanelModel node={node} />
      )}
    </Stack>
  );
};

export default NodePanelMain;
